module.exports = __webpack_public_path__ + "static/77-ed59bc89ffc1608e4b15e2ddfffc12eb.png";